export const contact = {
  uz: {
    mainContactTitle: "Biz bilan bog’laning",
    mainContactText:
      "Qabulga yozilish yoki konsultatsiya olish uchun istalgan qulay aloqa vositasi yordamida bizga bog’laning. Mutaxassislarimiz sizga qisqa vaqt ichida barcha savollaringizga javob berishadi.",
    mainContactFormTitle: "Konsultatsiya olish",
    mainContactFormName: "Ism",
    mainContactFormNamePlaceholder: "Ismingizni yozing",
    mainContactFormPhone: "Telefon raqam",
    mainContactFormPhonePlaceholder: "Telefon raqamingizni yozing",
    mainContactFormMsg: "Xabar",
    mainContactFormMsgPlaceholder: "Xabaringizni yozing",
    mainContactFormBtn: "Yuborish",
    mainContactWorkigTimeTitle: "Ish vaqti",
    mainContactWorkigTimeDuJu: "<b>Du-Ju:</b> 8:00–18:00",
    mainContactWorkigTimeShan: "<b>Sha:</b> 8:00–17:00",
    mainContactWorkigTimeYak: "<b>Ya:</b> dam olish kuni",
  },
  ru: {
    mainContactTitle: "Свяжитесь с нами",
    mainContactText:
      "Для записи на прием или консультации используйте любой удобный канал связи. Наши специалисты ответят вам в кратчайшие сроки и помогут решить все вопросы.",
    mainContactFormTitle: "Получить консультацию",
    mainContactFormName: "Имя",
    mainContactFormNamePlaceholder: "Ваше имя",
    mainContactFormPhone: "Телефон",
    mainContactFormPhonePlaceholder: "Ваш телефон",
    mainContactFormMsg: "Сообщение",
    mainContactFormMsgPlaceholder: "Напишите ваше сообщение",
    mainContactFormBtn: "Отправить",
    mainContactWorkigTimeTitle: "Режим работы",
    mainContactWorkigTimeDuJu: "<b>Пн-Пт:</b> 8:00–18:00",
    mainContactWorkigTimeShan: "<b>Сб:</b> 8:00–17:00",
    mainContactWorkigTimeYak: "<b>Вс:</b> выходной",
  },
  tj: {
    mainContactTitle: "Аризаро Ба <br/><span>Маркази Мо</span> фиристед",
    mainContactText:
      "Хавфи қурбонӣ шуданатон чӣ гуна аст? Унсури био, ки ба шумо барои нигоҳ доштани шаъну шараф кӯмак мекунад. Е Ҳамчун музоядачӣ, Август Морис, август як навъ гравита",
    mainContactFormTitle: "Машварат гиред",
    mainContactFormName: "Ном",
    mainContactFormNamePlaceholder: "Номи шумо",
    mainContactFormPhone: "Телефон",
    mainContactFormPhonePlaceholder: "Телефони шумо",
    mainContactFormMsg: "Паем",
    mainContactFormMsgPlaceholder: "Паеми худро ворид кунед",
    mainContactFormBtn: "Ирсол",
    mainContactWorkigTimeTitle: "Режим работы",
    mainContactWorkigTimeDuJu: "<b>Пн-Пт:</b> 8:00–18:00",
    mainContactWorkigTimeShan: "<b>Сб:</b> 8:00–17:00",
    mainContactWorkigTimeYak: "<b>Вс:</b> выходной",
  },
};
